import { useStoreActions } from "../../../contexts.ts";
import { QueryKeys } from "../queryKeys";
import { useQueryState } from "../useQueryState";
export const useProposalTemplates = function useProposalTemplates() {
  let {
    refreshOnMount
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    api
  } = useStoreActions();
  const {
    data,
    isLoading,
    refresh
  } = useQueryState({
    queryKey: [QueryKeys.ProposalTemplates],
    queryFn: () => {
      return api.proposalTemplates.getAll();
    },
    refreshOnHookMount: refreshOnMount
  });
  return {
    templates: data,
    isLoading,
    refresh
  };
};